export type ResultLineAuth =
  | 'errorCode'
  | 'errorFriendship'
  | 'NotLinkedToLine'
  | 'OtherErrors'

export interface TempState {
  redirectPayload: LineLoginResponse | null
  resultLineAuth: ResultLineAuth | null
}

export const Temp = {
  namespaced: true,
  state: (): TempState => ({
    redirectPayload: null,
    resultLineAuth: null
  }),
  mutations: {
    setRedirectPayload(state: TempState, payload: LineLoginResponse) {
      state.redirectPayload = payload
    },
    clearRedirectPayload(state: TempState) {
      state.redirectPayload = null
    },
    setResultLineAuth(state: TempState, payload: ResultLineAuth) {
      state.resultLineAuth = payload
    },
    clearResultLineAuth(state: TempState) {
      state.resultLineAuth = null
    },
  }
}
